export default __webpack_public_path__ + "static/logo_typo-62158a1441791bfa631fdca874ed10df.svg";